import { WSQueryConfig } from "@ws-react-query";
import { ApiQueryListWorkLogs, listWorkLogs } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_WORK_LOGS = "QUERY_WORK_LOGS";

export const useQueryWorkLogs = (
  query?: ApiQueryListWorkLogs,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof listWorkLogs>>,
    WSServiceError
  >
) => useWSQuery([QUERY_WORK_LOGS, query], () => listWorkLogs(query), config);
